import request from '@/utils/request'

// 查询版本升级列表分页
export function fetchList(query) {
    return request({
        url: '/biz/app-version/page',
        method: 'get',
        params: query,
    })
}
// 查询版本详细
export function getObj(id) {
    return request({
        url: '/biz/app-version/detail?id=' + id,
        method: 'get',
    })
}
// 新增版本
export function addObj(data) {
    return request({
        url: '/biz/app-version/add',
        method: 'post',
        data: data,
    })
}

// 修改版本
export function putObj(data) {
    return request({
        url: '/biz/app-version/edit',
        method: 'post',
        data: data,
    })
}
// 删除版本
export function delObj(data) {
    return request({
        url: '/biz/app-version/delete',
        method: 'post',
        data: data,
    })
}
